import React, {PureComponent} from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal,
} from 'reactstrap';
import TrendingDownIcon from 'mdi-react/TrendingDownIcon';
import axios from "axios";
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Util from "../../../Common/util";
import API from "../../../Common/api";

var url = window.location.hostname;
var port = window.location.port;

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

class PickingProductivityDetail extends PureComponent{
  
  state = {
    dataset : []
  }
  
  
  DetailSummary = () => {
    const payload = {
      "location": this.getCookie('selectedLocation'),
        "report_type": "PickingProductivity",
        "report_detailed" : ""
    };
    
    API.post('/reports/dashboardStaticCount/v1/', { param: payload })
    // axios('http://'+url+'/reports/dashboardStaticCount/v1/',
    // {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //   },
    //   data:{
    //     "location": this.getCookie('selectedLocation'),
    //     "report_type": "PickingProductivity",
    //     "report_detailed" : ""
    //   }
    // })
    .then((response) => {
		
	    var table_row= [];
    response.data.data = response.data.data.sort(function (a, b) {
      var textA = a["ET"];
      var textB = b["ET"];
      return textA > textB ? -1 : textA < textB ? 1 : 0;
    });
		for(let i=0;i < response.data.data.length;i++){
		    table_row.push({
        "PTL ID" : response.data.data[i]["PTL ID"],
        "Pick Type" : response.data.data[i]["Pick Type"],
        "Employee Name" : response.data.data[i]["Employee Name"],
        "Line" : response.data.data[i]["Line(#)"],
        "Lines/Hr" : response.data.data[i]["Lines/Hr"],
        
        "Quantity (pcs)" : response.data.data[i]["Quantity (pcs)"],
        "Quantity/Hr": response.data.data[i]["Quantity/Hr"],
        "ScannableQty" : response.data.data[i]["ScannableQty"],
        "ScannableQty/Hr" : response.data.data[i]["ScannableQty/Hr"],
        "ST" : response.data.data[i]["ST"],
				"ET" : response.data.data[i]["ET"],
				"Time Spent (min)" : response.data.data[i]["Time Spent (min)"]
			})
		}
		this.setState({
			dataset: table_row
		})
		
    })
  }
  
  exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }
  
  
   getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }
  
  
  
  componentDidMount(){
    if (port == 8091 || port === ":8090") {
      port = ":8090"
    }else{
      port = ":8088"
    }
	 if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }
	  
    this.DetailSummary();
  }
  
  
render(){
	 console.log(JSON.stringify(this.state.dataset));
	 const PickingProductivityData = {

      columns: [
{

          label:'PTL ID',
          field:'PTL ID',

        },
        {

          label:'Pick Type',
      field:'Pick Type'

        },
    
    {

          label:'Employee Name',
      field:'Employee Name'

        },

        {

          label:'Lines',
      field:'Line'

        },

        {

          label:'Lines/Hr',
          field:'Lines/Hr',


        },

        
    
    {

          label:'Quantity (pcs)',
      field:'Quantity (pcs)'

        },

        {

          label:'Quantity/Hr',
          field:'Quantity/Hr',


        },
        {

          label:'Scanned Qty',
      field:'ScannableQty'

        },
    {

          label:'Scanned Qty/Hr',
      field:'ScannableQty/Hr'

        },
        {

          label:'Start Time',
          field:'ST',

        },

        {

          label:'End Time',
		  field:'ET'

        },
		 

        

		{

          label:'Time Spent (min)',
		  field:'Time Spent (min)'

        },


        
      ],

      rows:this.state.dataset,

    }




    return (
	
	<Container>
    <Row>
      <Col md={10}>
        <h3 className="page-title">Picking Productivity</h3>
      </Col>
	  <Col md={2}>
        <span 
              className="pull-right" 
              onClick= {() => {this.exportToCSV(this.state.dataset,"PickingProductivity.xlsx")}} 
              style={{fontSize:'20px',paddingRight:'52px',cursor:'pointer',color:'#919193', marginTop: 12}}
              >
                <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
            </span>
      </Col>
    </Row>
   
    <Row>
      <Col xl={12}>
    <Card>
	<CardBody>
	<div className="table_val">
            <MDBDataTable
                striped
                bordered
                hover
                data={PickingProductivityData}
                sorting={true}
                paging = {true}
              />
            </div>
	</CardBody>
	</Card>
	</Col>
    </Row>

    
  </Container>
	
  );
  }
}

export default PickingProductivityDetail;
